<template>
  <div class="back-button" @click="handleClick">
    <a :href="href" @click.prevent><i class="icon icon-arrow-left-1"></i> {{ text }}</a>
  </div>
</template>

<script setup lang="ts">
defineProps<{
  handleClick: () => void
  text: string
  href: string
}>()
</script>

<style lang="scss" scoped>
.back-button {
  display: flex;
  gap: $spacing-1;
  cursor: pointer;
  font-weight: $font-medium;
  width: fit-content;

  a {
    color: $black;
    text-decoration: none;
  }

  &:hover {
    a {
      color: $brand-tertiary;
    }
  }
}
</style>
